import React from "react";
import Item from "../../../../../images/products/selected-item.svg";
import Category from "../../../../../images/products/category.svg";
import Money from "../../../../../images/sidebar/dollar-royal-blue.svg"; 
import RelatedItemContentRender from "./RelatedItemContentRender";
import { RelatedItemsModel } from "../models";
import { CategoryService, RelatedItemsService } from "../services";
import { CustomLabel, FlexContainer, IconButton } from "@mindmemobile/mm-shared-global";
import { DescriptionCell, LabelCell, ProductDetailWrapper } from "../styles";

type IProps = {
  item: RelatedItemsModel;
  label: string;
  description: JSX.Element;
  showOptions: boolean;
  onUpdate: (data: RelatedItemsModel) => void;
  reltedItemService: RelatedItemsService;
  categoryService?: CategoryService;
  hideIssueCredit?: boolean;
  multiplePriceSelection: boolean;
  sourceId?: string;
};
type OptionsData = {
  icon: string;
  name: string;
  onClick: () => void;
};
export default class RelatedItemContent extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
    this.onSelectItem = this.onSelectItem.bind(this);
    this.onShowCategories = this.onShowCategories.bind(this);
    this.onShowCredits = this.onShowCredits.bind(this);
  }

  get options(): OptionsData[] {
    return [
      {
        icon: Item,
        name: "Select Items",
        onClick: this.onSelectItem,
      } as OptionsData,
      {
        icon: Category,
        name: "Category",
        onClick: this.onShowCategories,
      } as OptionsData,
      {
        icon: Money,
        name: "Issue Credit",
        onClick: this.onShowCredits,
      } as OptionsData,
    ];
  }

  onSelectItem() {
    this.props.onUpdate(
      new RelatedItemsModel({
        ...this.props.item,
        showCategories: false,
        showAccountCredits: false,
        showSelectItems: true,
        showSelectItemsPopup: true,
      })
    );
  }

  onShowCategories() {
    this.props.onUpdate(
      new RelatedItemsModel({
        ...this.props.item,
        showAccountCredits: false,
        showSelectItems: false,
        showCategories: true,
      })
    );
  }

  onShowCredits() {
    this.props.onUpdate(
      new RelatedItemsModel({
        ...this.props.item,
        showCategories: false,
        showSelectItems: false,
        showAccountCredits: true,
      })
    );
  }

  get body(): React.ReactNode {
    const { label, description, showOptions, hideIssueCredit } = this.props;
    return (
      <FlexContainer className="padding-left-40-row">
        <LabelCell>
          <CustomLabel fontWeight="600">{label}</CustomLabel>
        </LabelCell>
        <DescriptionCell>
          <FlexContainer fxLayout="column" className="padding-left-40">
            <div>{description}</div>
            {showOptions && (
              <FlexContainer
                alignItems="center"
                spacing={20}
                className="padding-left-40-buttons"
              >
                {this.options.map((o, idx) => {
                  if (hideIssueCredit && o.name === "Issue Credit") return null;
                  return (
                    <IconButton key={idx} onClick={() => o.onClick()}>
                      <img src={o.icon} alt="icon" />
                      <label htmlFor="">{o.name}</label>
                    </IconButton>
                  );
                })}
              </FlexContainer>
            )}
          </FlexContainer>
          {!showOptions && (
            <RelatedItemContentRender
              sourceId={this.props.sourceId}
              reltedItemService={this.props.reltedItemService}
              categoryService={this.props.categoryService}
              item={this.props.item}
              multiplePriceSelection={this.props.multiplePriceSelection}
              onUpdate={(updatedItem) => this.props.onUpdate(updatedItem)}
            />
          )}
        </DescriptionCell>
      </FlexContainer>
    );
  }

  render() {
    return <ProductDetailWrapper>{this.body}</ProductDetailWrapper>;
  }
}
